"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.or = exports.noop = void 0;
exports.noop = () => null;
exports.or = (condition, _if, _else) => (condition ? _if : _else);
